package one.healthium.base.di

import one.healthium.base.preferences.AppPreferences
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

val baseUtilsModule = module {
    includes(baseUtilsPlatformModule())
    singleOf(::AppPreferences)
}